export default __webpack_public_path__ + "static/media/no-avatar.d6638d1f.jpg";